import React, { useState } from 'react';
import { ClipboardList, FilePlus, User, Calendar, FileText, Printer, Trash2 } from 'lucide-react';
import { useData } from '../context/DataContext';
import { toast } from 'sonner';
import BonEditor from '../components/BonEditor';
import PrintFactuur from '../components/PrintFactuur';
import { confirmDialog } from '../lib/confirm';

import { useT } from '../context/LanguageContext';
const eur = (n) => (n || 0).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });

const WERKSTATUSES = ['Concept', 'Open', 'Bezig', 'WachtenOpOnderdelen', 'Klaar', 'Afgesloten'];

export default function Werkkaart({ onNavigate }) {

  const { t } = useT();  const { bonnen, klanten, gegevens, setBonStatus, deleteBon, inkoopOrders } = useData();
  const [editorBon, setEditorBon] = useState(null);
  const [editorOpen, setEditorOpen] = useState(false);
  const [printBon, setPrintBon] = useState(null);

  const lopend = bonnen.filter(b => ['Concept', 'InBehandeling', 'InUitvoering', 'WachtenOpParts'].includes(b.status) || ['Bezig', 'WachtenOpOnderdelen', 'Open'].includes(b.werkStatus));

  const cycleWerkStatus = async (bon) => {
    const idx = WERKSTATUSES.indexOf(bon.werkStatus);
    const next = WERKSTATUSES[(idx + 1) % WERKSTATUSES.length];
    try { await setBonStatus(bon.id, { werkStatus: next }); toast.success(`Werkstatus: ${next}`); }
    catch { toast.error(t('Mislukt')); }
  };

  const handleDelete = async (bon) => {
    if (!(await confirmDialog(`${t('Werkbon verwijderen?', 'Werkbon verwijderen?')} ${bon.nummer || ''}`))) return;
    try { await deleteBon(bon.id); toast.success(t('Werkbon verwijderd', 'Werkbon verwijderd')); }
    catch { toast.error(t('Mislukt')); }
  };

  return (
    <div>
      <div className="cs-page-header">
        <div><h2>{t('page.workcard.title')}</h2><p>{lopend.length} {t('bonnen in behandeling', 'bonnen in behandeling')}</p></div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="cs-btn primary" onClick={() => { setEditorBon(null); setEditorOpen(true); }}><FilePlus size={14} /> {t('Nieuwe werkbon', 'Nieuwe werkbon')}</button>
        </div>
      </div>

      <div className="cs-card">
        <table className="cs-table">
          <thead><tr><th>{t('Nummer')}</th><th>{t('Datum')}</th><th>{t('Klant')}</th><th>{t('Kenteken')}</th><th>{t('Omschrijving')}</th><th>{t('Onderdelen besteld', 'Onderdelen besteld')}</th><th>{t('Werkstatus')}</th><th style={{textAlign:'right'}}>{t('Totaal')}</th><th></th></tr></thead>
          <tbody>
            {lopend.map(b => {
              const klant = klanten.find(k => k.id === b.klantId);
              const orders = (inkoopOrders || []).filter(o => o.bonId === b.id);
              const STATUS_CLS = { concept: 'gray', besteld: 'blue', deels_ontvangen: 'amber', ontvangen: 'green', geannuleerd: 'red' };
              return (
                <tr key={b.id} onDoubleClick={() => { setEditorBon(b); setEditorOpen(true); }}>
                  <td style={{ fontFamily: 'ui-monospace, monospace', fontWeight: 600 }}>{b.nummer}</td>
                  <td>{new Date(b.datum).toLocaleDateString('nl-NL')}</td>
                  <td>{klant?.naam || '-'}</td>
                  <td style={{ fontFamily: 'ui-monospace, monospace' }}>{b.kenteken}</td>
                  <td>{b.omschrijving}</td>
                  <td>
                    {orders.length === 0 ? <span style={{ color: 'var(--cs-text-muted)', fontSize: 12 }}>-</span> : (
                      <span style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }} data-testid={`werkkaart-orders-${b.id}`}>
                        {orders.map(o => <span key={o.id} className={`cs-badge ${STATUS_CLS[o.status] || 'gray'}`} title={o.nummer}>{o.nummer}</span>)}
                      </span>
                    )}
                  </td>
                  <td><button className={`cs-badge ${b.werkStatus === 'Bezig' ? 'amber' : b.werkStatus === 'WachtenOpOnderdelen' ? 'red' : 'blue'}`} style={{ border: 'none', cursor: 'pointer' }} onClick={() => cycleWerkStatus(b)} title={t('Klik om status te wijzigen')}>{b.werkStatus}</button></td>
                  <td style={{ textAlign: 'right', fontWeight: 600 }}>{b.totaal > 0 ? eur(b.totaal) : '-'}</td>
                  <td style={{ textAlign: 'right' }}>
                    <button className="cs-btn ghost" title={t('Open klant')} onClick={() => onNavigate && onNavigate('klanten')}><User size={12} /></button>
                    <button className="cs-btn ghost" title={t('Nieuwe planning')} onClick={() => onNavigate && onNavigate('planning')}><Calendar size={12} /></button>
                    <button className="cs-btn ghost" title={t('Print PDF')} onClick={() => setPrintBon(b)}><Printer size={12} /></button>
                    <button className="cs-btn ghost danger" title={t('Verwijderen', 'Verwijderen')} data-testid={`werkkaart-delete-${b.id}`} onClick={() => handleDelete(b)}><Trash2 size={12} /></button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {lopend.length === 0 && <div className="cs-empty">{t('Er is geen lopend werk.')}</div>}
      </div>

      {editorOpen && <BonEditor bon={editorBon} onClose={() => setEditorOpen(false)} />}
      {printBon && <PrintFactuur bon={printBon} klant={klanten.find(k => k.id === printBon.klantId)} gegevens={gegevens} onClose={() => setPrintBon(null)} />}
    </div>
  );
}
